import { ConductorOneChildActive } from "@frui.ts/screens";
import type { ScreenBase } from "@frui.ts/screens";
import ChargeDetailInfoViewModel from "./chargeDetailInfoViewModel";
import ChargeHistoriesViewModel from "./chargeHistoriesViewModel";
import type ChargeResponse from "entities/chargeResponse";
import type { interfaces } from "inversify";
import { action, computed } from "mobx";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import { formatLicensePlate } from "utils/localizations";
import ChargeRefundsViewModel from "./chargeRefundsViewModel";

export default class ChargeDetailViewModel extends ConductorOneChildActive<ScreenBase> {
  private readonly chargeDetailInfoViewModel: ChargeDetailInfoViewModel;
  private readonly chargeHistoriesViewModel: ChargeHistoriesViewModel;
  private readonly chargeRefundsViewModel: ChargeRefundsViewModel;

  constructor(
    private charge: ChargeResponse,
    private localizationService: LocalizationService,
    chargeDetailInfoViewModelFactory: ReturnType<typeof ChargeDetailInfoViewModel.Factory>,
    chargeHistoriesViewModelFactory: ReturnType<typeof ChargeHistoriesViewModel.Factory>,
    chargeRefundsViewModelFactory: ReturnType<typeof ChargeRefundsViewModel.Factory>
  ) {
    super();
    this.chargeDetailInfoViewModel = chargeDetailInfoViewModelFactory(this.charge);
    this.chargeHistoriesViewModel = chargeHistoriesViewModelFactory(this.charge);
    this.chargeRefundsViewModel = chargeRefundsViewModelFactory(this.charge);
    this.children.push(this.chargeDetailInfoViewModel, this.chargeHistoriesViewModel, this.chargeRefundsViewModel);
    this.navigationName = "";
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  @computed
  get name() {
    return this.localizationService
      .translateModule(Modules.callCenter, "chargeDetail.title")
      .replace("%licensePlate%", formatLicensePlate(this.charge.vehicle));
  }

  @action.bound
  onClose() {
    this.requestClose();
  }

  static Factory({ container }: interfaces.Context) {
    return (chargeResponse: ChargeResponse) =>
      new ChargeDetailViewModel(
        chargeResponse,
        container.get(LocalizationService),
        container.get(ChargeDetailInfoViewModel.Factory),
        container.get(ChargeHistoriesViewModel.Factory),
        container.get(ChargeRefundsViewModel.Factory)
      );
  }
}
